import React, { createContext, useState, useContext, useEffect } from 'react';

// Create a context
const CookieConsentContext = createContext();

// Custom hook to use the cookie consent context
export const useCookieConsent = () => useContext(CookieConsentContext);

// Provider component
export const CookieConsentProvider = ({ children }) => {
  const [consentGiven, setConsentGiven] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true, // Always required
    analytics: false,
    marketing: false,
    preferences: false
  });

  // Load saved preferences on mount
  useEffect(() => {
    const consentStatus = localStorage.getItem('cookieConsent');
    if (consentStatus === 'accepted' || consentStatus === 'customized') {
      setConsentGiven(true);
      
      try {
        const savedPrefs = JSON.parse(localStorage.getItem('cookiePreferences'));
        if (savedPrefs) {
          setPreferences(savedPrefs);
        }
      } catch (err) {
        console.error('Error parsing cookie preferences:', err);
      }
    }
  }, []);

  const acceptAll = () => {
    setConsentGiven(true);
    setPreferences({
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true
    });
  };

  const rejectAll = () => {
    setConsentGiven(true);
    setPreferences({
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    });
  };

  const savePreferences = (newPrefs) => {
    setConsentGiven(true);
    setPreferences(newPrefs);
  };

  // Check if a specific cookie type is allowed
  const isAllowed = (cookieType) => {
    if (!consentGiven) return cookieType === 'necessary';
    return preferences[cookieType] || false;
  };

  return (
    <CookieConsentContext.Provider 
      value={{ 
        consentGiven, 
        preferences, 
        setPreferences,
        acceptAll, 
        rejectAll, 
        savePreferences,
        isAllowed
      }}
    >
      {children}
    </CookieConsentContext.Provider>
  );
};

export default CookieConsentContext;
